import { isObject } from 'lodash'

import { SCROLL_TO_COMMENTS } from '@/utils/query-parameters'
import { deleteQueryParameter } from '@/utils/router'

export const COMMENT_SECTION_ID = 'comments-section'

export const scrollToElementId = elementId => {
  const sectionElement = document.getElementById(elementId)
  if (sectionElement) {
    sectionElement.scrollIntoView()
  }
}

export const shouldScrollToComments = payload => {
  const shouldScrollByQueryParameter = payload?.route?.query[SCROLL_TO_COMMENTS] === 'true'

  return Boolean(payload?.shouldScroll || shouldScrollByQueryParameter)
}

const clearScrollToCommentsQueryParameter = payload => {
  if (!isObject(payload?.router) || !isObject(payload?.route) || !isObject(payload?.route?.query))
    return false

  const hasScrollToCommentsQueryParameter = SCROLL_TO_COMMENTS in payload.route.query
  if (!hasScrollToCommentsQueryParameter) return

  deleteQueryParameter(payload?.router, payload?.route, SCROLL_TO_COMMENTS)
}

export const scrollToComments = payload => {
  scrollToElementId(COMMENT_SECTION_ID)
  clearScrollToCommentsQueryParameter(payload)
}
